import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'services',
    labelKey: 'chatbot.suggestions.services',
    messageKey: 'chatbot.suggestions.servicesMessage',
  },
  {
    id: 'production',
    labelKey: 'chatbot.suggestions.production',
    messageKey: 'chatbot.suggestions.productionMessage',
  },
  {
    id: 'contact',
    labelKey: 'chatbot.suggestions.contact',
    messageKey: 'chatbot.suggestions.contactMessage',
  },
  {
    id: 'certifications',
    labelKey: 'chatbot.suggestions.certifications',
    messageKey: 'chatbot.suggestions.certificationsMessage',
  },
]

export const contactCTAs: ContactCTA[] = [
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 059.512504',
  },
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'sales@lifeelettronica.com',
  },
]
